import React from 'react'
import styles from './styles.module.css'
import Hero from '../Hero'
import Text from '../../../Text'
import Step1 from '../Step1'
import Step2 from '../Step2'
import Step3 from '../Step3'
import Step4 from '../Step4'
import Step5 from '../Step5'
import Step6 from '../Step6'
import Youtube from '../../../Youtube'
import CtaV2 from '../../../CtaV2'
import heroStyles from '../Hero/styles.module.css'

function CreatorsProgramPage({ title,
                               heroVideoUrl, heroTitleHl, heroText, ctaV2 }) {

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <Hero videoUrl={'https://www.youtube.com/watch?v=TKndQwXqbBo'} titleHl={heroTitleHl} text={heroText} ctaV2={ctaV2}/>
        <div className={styles.howItWorks}><Text type="heading-1">HOW IT WORKS</Text></div>
        <div className={styles.steps}>
          <Step1/>
          <Step2/>
          <Step3/>
          <Step4/>
          <Step5/>
          <Step6/>
        </div>
        <div className={styles.footer}>
          <div className={styles.footerText}><Text type="heading-1">VRS® CREATORS PROGRAM</Text></div>
          <div className={styles.footerVideo}>
            <Youtube url="https://www.youtube.com/watch?v=hQZdt-3jE-8" height="394"/>
          </div>
          <div className={heroStyles.ctaWrapper}><CtaV2 {...ctaV2} fullWidth sx={{ height: '80px', titleTextType: 'large' }}/></div>
        </div>
      </div>
    </div>
  )
}

export default CreatorsProgramPage
